document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('mixmatch');
  if (!root) return;

  var addAllBtn = root.querySelector('#mmx-add-all');
  if (!addAllBtn) return;

  function getTotalQty() {
    var total = 0;
    root.querySelectorAll('.mmx-qty input').forEach(function (inp) {
      var v = parseInt(inp.value, 10);
      if (!isNaN(v)) total += v;
    });
    return total;
  }

  function updateFooterLabel() {
    var total = getTotalQty();
    addAllBtn.textContent = total > 0 ? 'Add' : 'Select';
  }

  function updateCardButtons() {
    root.querySelectorAll('.mmx-card').forEach(function (card) {
      var btn = card.querySelector('.mmx-add');
      if (!btn) return;

      var hasQty = false;
      card.querySelectorAll('.mmx-qty input').forEach(function (inp) {
        var v = parseInt(inp.value, 10);
        if (!isNaN(v) && v > 0) hasQty = true;
      });

      if (hasQty) {
        btn.textContent = 'Add';
        btn.classList.remove('added');
      } else {
        btn.textContent = 'Select';
        btn.classList.remove('added');
      }
    });
  }

  function refreshLabels() {
    updateFooterLabel();
    updateCardButtons();
  }

  // Set initial labels based on current selections
  refreshLabels();

  // Watch quantity controls to update labels when user changes sizes/quantities
  root.addEventListener('click', function (event) {
    var target = event.target;
    if (!target) return;
    var act = target.getAttribute('data-act');
    if (act === 'plus' || act === 'minus' || act === 'trash') {
      // Allow the original script to update the quantity inputs first
      setTimeout(refreshLabels, 0);
    }
  });

  // Per-card Add behaviour: when a card button shows 'Add', clicking it adds that card's sizes to cart
  root.addEventListener('click', function (event) {
    var target = event.target;
    if (!target) return;
    var btn = target.closest('.mmx-add');
    if (!btn) return;

    var label = (btn.textContent || '').trim().toLowerCase();
    if (label !== 'add') return;

    // Intercept before the original click handler toggles the drawer
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    var card = btn.closest('.mmx-card');
    if (!card) return;

    var items = [];
    card.querySelectorAll('.mmx-row').forEach(function (row) {
      var qtyInput = row.querySelector('.mmx-qty input');
      if (!qtyInput) return;
      var qty = parseInt(qtyInput.value, 10);
      if (!qty || qty <= 0) return;
      var idStr = row.getAttribute('data-variant');
      if (!idStr) return;
      var id = Number(idStr);
      if (!id) return;
      items.push({ id: id, quantity: qty });
    });

    if (!items.length) {
      alert('Please select at least one size for this glove.');
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-MixMatch': 'true'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add error');
        return response.json().catch(function () { return null; });
      })
      .then(function () {
        // Clear this card's quantities and refresh labels
        card.querySelectorAll('.mmx-qty input').forEach(function (inp) {
          inp.value = '0';
        });
        refreshLabels();
        btn.textContent = 'Added';
        btn.disabled = false;
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
        alert('Error adding items to cart. Please try again.');
      });
  }, true);
});
